let BaseUrl;
switch (process.env.NODE_ENV) {
  case "development":
    BaseUrl = {
      dev: "https://karm.pythonanywhere.com",
    };
    break;
  case "production":
    BaseUrl = {
      dev: "https://karm.pythonanywhere.com",
    };
    break;
  default:
    BaseUrl = {
      dev: "https://karm.pythonanywhere.com",
    };
    break;
}

export default BaseUrl;
